module.exports = __webpack_public_path__ + "static/media/yelp_logo.0653b58a.png";